const unitTemplates = {}

import unitJobs from "@frog/source/data/unitJobs.js"
Object.keys(unitJobs).forEach((unitJobKey) => {
    unitTemplates["jobs/" + unitJobKey] = {
        "templateKey": "jobs/" + unitJobKey,
        "jobKey": unitJobKey,
    }
})

export const UNIT_JOB_LISTS = {
    "infantry": ["sword", "spear", "axe"],
    "ranged": ["dagger", "bow", "gun"],
    "mounted": ["swordcavalier", "spearcavalier", "axecavalier"],
    "armored": ["swordknight", "spearknight", "axeknight"],
    "swordhavers": ["sword", "dagger", "swordknight", "swordcavalier"],
    "spearhavers": ["spear", "bow", "spearknight", "spearcavalier"],
    "axehavers": ["axe", "gun", "axeknight", "axecavalier"],
    "melee": [
        "sword", "spear", "axe",
        "swordknight", "spearknight", "axeknight",
        "swordcavalier", "spearcavalier", "axecavalier"
    ],
    "basic": [
        "sword", "spear", "axe",
        "dagger", "bow"
    ],
    "advanced": [
        "sword", "spear", "axe", "dagger", "bow",
        "sword", "spear", "axe", "dagger", "bow",
        "swordknight", "spearknight", "axeknight",
        "swordcavalier", "spearcavalier", "axecavalier",
    ]
}
for(const [key, value] of Object.entries(UNIT_JOB_LISTS)) {
    unitTemplates["randoms/" + key] = {
        "randomJobKey": value.join(","),
        "templateKey": "randoms/" + key,
        "affiliation": "bad",
    }
}

unitTemplates["universal"] = {
    "affiliation": "bad",
    "templateKey": "universal",
}

unitTemplates["tree"] = {
    "templateKey": "tree",
    "type": "zone",
    "role": "tree",
    "stack": -1,
    "properties": ["no healthbar"],
    // "imageUrl": require("@frog/source/assets/images/horror-tactics/warning-redo-1.png"),
    "imageKey": "book/mess",
    "spriteSize": "contained",
}

import games from "@frog/source/data/games/index.js"
Object.keys(games).forEach((gameKey) => {
    const game = games[gameKey]
    Object.keys(game.player.party.units).forEach((unitKey) => {
        unitTemplates["player/" + gameKey + "/" + unitKey] = {
            "templateKey": "player/" + gameKey + "/" + unitKey,
            "key": unitKey
        }
    })
})

export default unitTemplates
